import React from "react";
import ContactedPage from "./ContactedPage";

const InactivePage = () => {
  return (
    <div>
      <ContactedPage />
    </div>
  );
};

export default InactivePage;
